$mol_icon_minus $mol_icon path \M19,13H5V11H19V13Z
